import Vue from "vue";

Vue.directive("clickoutside", {
  bind: function (el, binding, vnode) {
    const handleClick = (e) => {
      if (!el.contains(e.target)) {
        vnode.context[binding.expression](e);
      }
    };

    document.addEventListener("click", handleClick);

    el.__vueClickOutside__ = handleClick;
  },
  unbind: function (el) {
    document.removeEventListener("click", el.__vueClickOutside__);
    delete el.__vueClickOutside__;
  },
});

Vue.directive("sust-tooltip", {
  bind(el, binding) {
    const { value } = binding;
    const text = typeof value === 'string' ? value : value.text || '';
    const position = value.position || 'bottom';

    const tooltip = document.createElement('div');
    tooltip.className = `sust-tooltip tooltip-${position}`;
    tooltip.textContent = text;

    Object.assign(tooltip.style, {
      position: 'absolute',
      backgroundColor: binding.value.bgColor ? binding.value.bgColor : "var(--carbon)",
      maxWidth: '150px',
      color: '#fff',
      padding: '.4em .8em',
      borderRadius: '.25em',
      fontSize: value.fontSize ? value.fontSize : '.75vw',
      whiteSpace: 'wrap',
      zIndex: 9999999,
      transition: 'opacity 200ms',
      opacity: 0,
      pointerEvents: 'none'
    });

    const showTooltip = () => {
      if (value.condition != undefined && value.condition === false) return;

      document.body.appendChild(tooltip);
      const rect = el.getBoundingClientRect();
      const ttRect = tooltip.getBoundingClientRect();

      let top = 0, left = 0;

      switch (position) {
        case 'top':
          top = rect.top - ttRect.height - 8;
          left = rect.left + (rect.width - ttRect.width) / 2;
          break;
        case 'bottom':
          top = rect.bottom + 8;
          left = rect.left + (rect.width - ttRect.width) / 2;
          break;
        case 'left':
          top = rect.top + (rect.height - ttRect.height) / 2;
          left = rect.left - ttRect.width - 8;
          break;
        case 'right':
          top = rect.top + (rect.height - ttRect.height) / 2;
          left = rect.right + 8;
          break;
      }

      tooltip.style.top = `${top + window.scrollY}px`;
      tooltip.style.left = `${left + window.scrollX}px`;
      tooltip.style.opacity = .9;
    };

    const hideTooltip = () => {
      if (tooltip.parentNode) {
        tooltip.parentNode.removeChild(tooltip);
      }
    };

    el._tooltipHandlers = { showTooltip, hideTooltip };
    el.addEventListener('mouseenter', showTooltip);
    el.addEventListener('mouseleave', hideTooltip);
  },

  unbind(el) {
    const { showTooltip, hideTooltip } = el._tooltipHandlers || {};
    el.removeEventListener('mouseenter', showTooltip);
    el.removeEventListener('mouseleave', hideTooltip);

    const tooltips = document.querySelectorAll('.sust-tooltip');
    tooltips.forEach(tt => {
      if (tt && tt.parentNode) {
        tt.parentNode.removeChild(tt);
      }
    });

    delete el._tooltipHandlers;
  }
});

Vue.directive('focus-on-render', {
  inserted(el) {
    el.focus();
  }
});


Vue.directive('context-menu', {
  bind(el, binding) {
    const event_type = binding.value.eventType || 'contextmenu';

    const showContextMenu = (event) => {
      const contextMenuNodes = document.querySelectorAll('.context-menu');
      contextMenuNodes.forEach(cm => cm.remove());

      let { items, onItemClick, position, data } = binding.value;
      position = position || 'bottom';

      const context_menu = document.createElement('div');
      context_menu.className = `context-menu context-menu-${position}`;

      for (let idx = 0; idx < items.length; idx++) {
        const item = items[idx];
        const context_menu_item = document.createElement('div');
        
        context_menu_item.setAttribute('key', item.key);
        context_menu_item.textContent = item.text;
        context_menu_item.classList.add('context-menu-item');
        context_menu_item.addEventListener('click', (event) => {
          event.stopPropagation();
          if (typeof onItemClick === 'function') {
            onItemClick(item.key, data);
          }

          context_menu.remove();
        });

        context_menu.appendChild(context_menu_item);
      }

      event.preventDefault();
      document.body.appendChild(context_menu);
      const rect = el.getBoundingClientRect();
      const cmRect = context_menu.getBoundingClientRect();

      let top = 0, left = 0;

      const OFFSET = 8;
      switch (position) {
        case 'top':
          top = rect.top - cmRect.height - OFFSET;
          left = rect.left + (rect.width - cmRect.width) / 2;
          break;
        case 'bottom':
          top = rect.bottom + OFFSET;
          left = rect.left + (rect.width - cmRect.width) / 2;
          break;
        case 'left':
          top = rect.top + (rect.height - cmRect.height) / 2;
          left = rect.left - cmRect.width - OFFSET;
          break;
        case 'right':
          top = rect.top + (rect.height - cmRect.height) / 2;
          left = rect.right + OFFSET;
          break;
      }

      context_menu.style.top = `${top + window.scrollY}px`;
      context_menu.style.left = `${left + window.scrollX}px`;

      setTimeout(() => {
        const hideContextMenu = (e) => {
          if (!context_menu.contains(e.target)) {
            context_menu.remove();
            document.removeEventListener('click', hideContextMenu);
          }
        };
        document.addEventListener('click', hideContextMenu);
      }, 0);
    };

    const hideContextMenu = (event, context_menu) => {
      if (!context_menu.contains(event.target)) {
        if (context_menu.parentNode) {
          context_menu.parentNode.removeChild(context_menu);
          document.removeEventListener('click', hideContextMenu);
        }
      }
    };

    el._contextMenuHandlers = { showContextMenu, hideContextMenu };
    el.addEventListener(event_type, showContextMenu);
  },

  unbind(el) {
    const { showContextMenu } = el._contextMenuHandlers || {};
    el.removeEventListener('mouseenter', showContextMenu);

    const contextMenuNodes = document.querySelectorAll('.context-menu');
    contextMenuNodes.forEach(cm => cm.remove());

    delete el._contextMenuHandlers;
  }
});